import { useCallback, useEffect, useState } from 'react';

import axios from 'axios';

import authEndpoints from 'config/api/auth';
import PATHS from 'router/PATHS';

export const DEFAULT_SIGNUP_REDIRECT_URL = 'https://pocketsafe.se/kontakta-oss/';

export type SignupConfig = {
  selfServiceSignupEnabled: boolean;
  signupRedirectUrl: string;
};

export const DEFAULT_SIGNUP_CONFIG: SignupConfig = {
  selfServiceSignupEnabled: false,
  signupRedirectUrl: DEFAULT_SIGNUP_REDIRECT_URL,
};

export const getSignupConfig = async (): Promise<SignupConfig> => {
  try {
    const { data } = await axios(authEndpoints.signup_redirect());
    return {
      selfServiceSignupEnabled: Boolean(data?.self_service_signup_enabled),
      signupRedirectUrl: data?.signup_redirect_url || DEFAULT_SIGNUP_REDIRECT_URL,
    };
  } catch (_error) {
    return DEFAULT_SIGNUP_CONFIG;
  }
};

const useSignupRedirectUrl = () => {
  const [signupConfig, setSignupConfig] = useState<SignupConfig>(DEFAULT_SIGNUP_CONFIG);

  useEffect(() => {
    let isMounted = true;

    getSignupConfig().then(config => {
      if (isMounted) setSignupConfig(config);
    });

    return () => {
      isMounted = false;
    };
  }, []);

  const getSignupUrl = useCallback(
    (config: SignupConfig = signupConfig) => (config.selfServiceSignupEnabled ? PATHS.AUTH_REGISTER : config.signupRedirectUrl),
    [signupConfig],
  );

  const redirectToSignup = useCallback(async () => {
    const config = await getSignupConfig();
    window.location.assign(getSignupUrl(config));
  }, [getSignupUrl]);

  return {
    getSignupUrl,
    redirectToSignup,
    selfServiceSignupEnabled: signupConfig.selfServiceSignupEnabled,
    signupFallbackUrl: getSignupUrl(),
    signupConfig,
  };
};

export default useSignupRedirectUrl;
